import { createAction, props } from '@ngrx/store';
import {
  BugReport,
  BugReportInput,
  BugReportViewedInput,
  FeedbackAnalytics,
  FeedbackForAdmin,
  FeedbackInput,
  SystemStatusReport,
  SystemStatusReportInput,
  TogglePublishAllSystemStatusReportInput
} from '@cpd-app/generated';

export const getIssues = createAction('[System Status] get issues');

export const getIssuesSuccess = createAction(
  '[System Status] get issues success',
  props<{ issues: BugReport[] }>()
);

export const getIssuesFailure = createAction(
  '[System Status] get issues failure',
  props<{ error: any }>()
);

export const getSystemReports = createAction(
  '[System Status] get system reports'
);

export const getSystemReportsSuccess = createAction(
  '[System Status] get system reports success',
  props<{ systemReports: SystemStatusReport[] }>()
);

export const getSystemReportsFailure = createAction(
  '[System Status] get system reports failure',
  props<{ error: any }>()
);

export const reportBug = createAction(
  '[System Status] report bug',
  props<{ input: BugReportInput }>()
);

export const reportBugSuccess = createAction(
  '[System Status] report bug success',
  props<{ issue: BugReport }>()
);

export const reportBugFailure = createAction(
  '[System Status] report bug failure',
  props<{ error: any }>()
);

export const feedback = createAction(
  '[System Status] feedback',
  props<{ input: FeedbackInput }>()
);

export const feedbackSuccess = createAction('[System Status] feedback success');

export const feedbackFailure = createAction(
  '[System Status] feedback failure',
  props<{ error: any }>()
);

export const getFeedbacks = createAction('[System Status] get feedbacks');

export const getFeedbacksSuccess = createAction(
  '[System Status] get feedbacks success',
  props<{ feedbacks: FeedbackForAdmin[] }>()
);

export const getFeedbacksFailure = createAction(
  '[System Status] get feedbacks failure',
  props<{ error: any }>()
);

export const getFeedbackAnalytics = createAction(
  '[System Status] get feedback analytics'
);

export const getFeedbackAnalyticsSuccess = createAction(
  '[System Status] get feedback analytics success',
  props<{ analytics: FeedbackAnalytics }>()
);

export const getFeedbackAnalyticsFailure = createAction(
  '[System Status] get feedbacks analytics failure',
  props<{ error: any }>()
);

export const createSystemStatusReport = createAction(
  '[System Status] create system status report',
  props<{ input: SystemStatusReportInput }>()
);

export const createSystemStatusReportSuccess = createAction(
  '[System Status] create system status report success',
  props<{ report: SystemStatusReport }>()
);

export const createSystemStatusReportFailure = createAction(
  '[System Status] create system status report failure',
  props<{ error: any }>()
);
export const togglePublishAllSystemStatusReport = createAction(
  '[System Status] toggle publish all system status report',
  props<{ input: TogglePublishAllSystemStatusReportInput }>()
);

export const togglePublishAllSystemStatusReportSuccess = createAction(
  '[System Status] toggle publish all system status report success',
  props<{ reports: SystemStatusReport[] }>()
);

export const togglePublishAllSystemStatusReportFailure = createAction(
  '[System Status] toggle publish all system status report failure',
  props<{ error: any }>()
);

export const deleteSystemStatusReport = createAction(
  '[System Status] delete system status report',
  props<{ ids: string[] }>()
);

export const deleteSystemStatusReportSuccess = createAction(
  '[System Status] delete system status report success',
  props<{ success: boolean }>()
);

export const deleteSystemStatusReportFailure = createAction(
  '[System Status] delete system status report failure',
  props<{ error: any }>()
);

export const markBugReportsViewed = createAction(
  '[System Status] mark bug reports viewed',
  props<{ input: BugReportViewedInput }>()
);

export const markBugReportsViewedSuccess = createAction(
  '[System Status] mark bug reports viewed success',
  props<{ issues: BugReport[] }>()
);

export const markBugReportsViewedFailure = createAction(
  '[System Status] mark bug reports viewed failure',
  props<{ error: any }>()
);
